import { ILang } from 'types/mainPage';
import { NAMES } from 'utils/constantNames';

export const langs: ILang[] = [
  { lang: NAMES.LANG_RUS, value: 'ru' },
  { lang: NAMES.LANG_BEL, value: 'by' },
  { lang: NAMES.LANG_ENG, value: 'en' },
];
